import PlatformTemplate from './PlatformTemplate'

export default PlatformTemplate
